import { render, staticRenderFns } from "./DtNotes.vue?vue&type=template&id=1fa2fd8a&"
import script from "./DtNotes.vue?vue&type=script&lang=js&"
export * from "./DtNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports